import styled from 'styled-components';
import { paradigmLightBlue } from '@paradigm/design-system/src/colors';
import { MOBILE_BREAKPOINT } from '#/containers/layout/constants';

const ConfirmButton = styled.button`
  border: none;
  position: relative;
  box-sizing: border-box;
  text-align: center;
  background-color: transparent;
  line-height: 22px;
  height: 22px;
  font-size: 13px;
  font-weight: bold;
  text-transform: capitalize;
  color: ${paradigmLightBlue};
  margin-bottom: 3px;
  transition: border 0.25s ease;
  border-bottom: 1px solid transparent;

  &:hover {
    border-bottom: 1px solid ${paradigmLightBlue};
  }
  @media (max-width: ${MOBILE_BREAKPOINT}px) {
    font-size: 1rem;
  }
`;

export default ConfirmButton;
